export default __webpack_public_path__ + "static/media/learning-logo.27f80870.png";